import { WorkTaskDailyEntryProxy } from "../api/proxies/work-task-daily-entry-proxy";
import { PagingInfo } from "api/paging-info";
import { autoinject } from "aurelia-framework";

import { HttpClientRequestConfig } from "http-client/http-client-request-config";

import { WorkTaskModel } from "api/models/company/work-task-model";

@autoinject()
export class WorkTaskDailyEntryService {
    constructor(private readonly workTaskDailyEntryProxy: WorkTaskDailyEntryProxy) { }

    public async GetTasks(filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<WorkTaskModel[] | null> {
        return await this.workTaskDailyEntryProxy.GetTasks(filter, pagingInfo, requestConfig);
    }
}
